import React, { FC } from "react"
import { Table } from "@/components"
import { dateFormat1, dollarUS } from "@/lib/services"
import { Order } from "@/lib/types"

type Props = {
  title: string
  listingData: { deliveries: Order[] }
  header: {
    name: string
    width: string
  }[]
}
export const RecentDeliveries: FC<Props> = (props) => {
  return (
    <div className="m-4">
      <Table
        header={props.header}
        headerAlign="text-left"
        lastheadingAlign="text-right"
      >
        {props.listingData.deliveries.map((e, i) => (
          <tr key={i} className="text-left">
            <td className="whitespace-nowrap p-4 w-48">
              {dateFormat1(e.deliveryDate)}
            </td>
            <td className="whitespace-nowrap p-4 w-48">
              {e.user.firstName} {e.user.lastName}
            </td>
            <td className="whitespace-nowrap p-4 w-48">{e.origin}</td>
            <td className="whitespace-nowrap p-4 w-48">{e.destination}</td>
            <td className="whitespace-nowrap p-4 w-48">{e.equipment}</td>
            <td className="whitespace-nowrap p-4 w-48">
              {dollarUS.format(e.cost)}
            </td>
            <td className="whitespace-nowrap text-right p-4 w-48">
              {dollarUS.format(e.price)}
            </td>
          </tr>
        ))}
      </Table>
    </div>
  )
}
